import React from "react";

import CreationForm from "./configuration-creation-form";
import MaterialTable from "material-table";
import service from "../../../../../plas/services/calls/service.jsx";

function TableForms({
  open
}) {

  const [create, setCreate] = React.useState(false);
  const tableRef = React.useRef();

  return (
    <div>
      <MaterialTable
        tableRef={tableRef}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsPerPage: "Filas por página",
            labelRowsSelect: "Filas",
            firstAriaLabel: "Primera página",
            firstTooltip: "Primera página",
            previousAriaLabel: "Página anterior",
            previousTooltip: "Página anterior",
            nextAriaLabel: "Próxima página",
            nextTooltip: "Próxima página",
            lastAriaLabel: "Última página",
            lastTooltip: "Última página",
          },
          toolbar: {
            nRowsSelected: "{0} filas(s) seleccionadas",
            searchTooltip: "Buscar",
            searchPlaceholder: "Buscar",
          },
          header: {
            actions: "Acciones",
          },
          body: {
            emptyDataSourceMessage: "No hay formularios para mostrar",
            deleteTooltip: "Eliminar",
            editTooltip: "Editar",
            filterRow: {
              filterTooltip: "Filtrar",
            },
            editRow: {
              saveTooltip: "Confirmar",
              cancelTooltip: "Cancelar",
              deleteText: "¿Está seguro que desea eliminar el formulario?",
            },
          },

        }}
        title="Formularios"
        columns={[
          { title: "ID", field: "id",  editable: "never", cellStyle: {width:"5%"}, headerStyle:{width:"5%"},
          render: rowData => <span>{rowData.id}</span>},
          { title: "Nombre", field: "name", sorting: false, cellStyle: {width:"25%"}, headerStyle:{width:"25%"},
          render: rowData => <span>{rowData.name}</span>},
          { title: "Descripción", field: "description",sorting: false, cellStyle: {width:"50%"}, headerStyle:{width:"50%"},
            render: rowData => <span>{rowData.description}</span>},
          { title: "Convocatorias", field: "assigned", sorting: false, editable: "never", cellStyle: {width:"10%"}, headerStyle:{width:"10%"},
            render: rowData => <span>{rowData.assigned > 0 ? rowData.assigned : "Ninguna"}</span>},
          { title: "Editable", field: "editable", sorting: false, editable: "never", cellStyle: {width:"10%"}, headerStyle:{width:"10%"},
            render: rowData => <span>{rowData.usedBy === 0 ? "Si" : "No"}</span>},
        ]}
        actions={[
          rowData => ({
            icon: "launch",
            tooltip: "Abrir",
            onClick: (event, rowData) => open(event, rowData)
          }),
          {
            icon: "add",
            tooltip: "Crear formulario",
            isFreeAction: true,
            onClick: (event) => { setCreate(true); },
          },
        ]}
        options={{
          sorting: false,
          draggable: false,
          addRowPosition: "first",
          actionsColumnIndex: -1,
          tableLayout: 'auto',
          actionsCellStyle: {width: "10%"},
          rowStyle: {
            fontSize: 15,
          }
        }}
        editable={{
          isDeletable: rowData => rowData.assigned === 0,
          onRowDelete: (oldData) =>
            new Promise((resolve) => {
              service.api.configurations.delete(oldData.id,(response) => {
                resolve();
              });
            })
        }}
        data={ query =>
          new Promise((resolve, reject) => {
            let from = query.page * query.pageSize;
            let to = from + query.pageSize;
            let keyword = query.search;

            service.api.configurations.getPage(from,to,keyword,(response) => {
              if (response.result != null) {
                resolve({
                  data: response.result.data,
                  page: query.page,
                  totalCount: response.result.total,
                });
              } else {
                reject();
              }
            }); 
          })
        }
      />
      <CreationForm 
        open={create} 
        cancel={() => {
          setCreate(false)
        }} 
        created={() => { 
          setCreate(false); 
          if (tableRef.current !== undefined && tableRef.current != null) {
            tableRef.current.onQueryChange()
          }
        }}/>
    </div>
  );

}

export default TableForms;
